export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Poll-Notification-Gray-816db9d12576dee2f441b36bf0369ff2.svg";